import React from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DownloadOutlined } from '@ant-design/icons';
import { DocumentStaticFile } from '@interfaces/KnowledgeTransfer';
import { useTranslate } from '@translations/useTranslate';
import styles from './DocumentCard.module.scss';

const DocumentCard: React.FC<DocumentStaticFile> = ({
  documentTitle,
  documentDescription,
  fileTypes,
  link,
  fileName,
  tags,
  category,
  language,
  date, // assuming you have a date field
}) => {
  const { t } = useTranslate();

  const handleDownload = () => {
    const linkDom = document.createElement('a');
    linkDom.href = link;
    linkDom.download = fileName;
    linkDom.click();
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.category}>{category}</span>
        <span className={styles.date}>{date || '22.12.2025'}</span>
      </div>

      <div className={styles.section}>
        <h3 className={styles.title}>{documentTitle}</h3>

        <p className={styles.description}>
          {documentDescription.length > 200
            ? documentDescription.substring(0, 188)
            : documentDescription}
          {documentDescription.length > 200 && (
            <OverlayTrigger
              placement="auto"
              overlay={<Tooltip id="tooltip-1">{documentDescription}</Tooltip>}
            >
              <Nav.Link className={styles.nav_link}>{t('knowledgecenter.readmore.link')}</Nav.Link>
            </OverlayTrigger>
          )}
        </p>

        <div className={styles.fileTags}>
          {tags.map((tag, index) => (
            <span key={index} className={styles.fileTag}>
              {tag}
            </span>
          ))}
        </div>

        <div className={styles.language}>
          {t('knowledgecenter.language.label')}: <strong>{language}</strong>
        </div>
      </div>

      <div className={styles.bottonWrapper}>
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id={`tooltip-${fileName}`}>{fileName}</Tooltip>}
        >
          <button className={styles.downloadButton} onClick={handleDownload}>
            {t('knowledgecenter.download.button')} <DownloadOutlined />
          </button>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export { DocumentCard };
